module.exports = __webpack_public_path__ + "static/media/offline-image.0b05974c.svg";